"use client";

import { createContext, useContext } from "react";

/**
 * コンテキスト-マイページデータ
 */
export type MypageCommonContext = {
  isSidebarOpen: boolean;
};

/**
 * コンテキスト-マイページデータ設定関数
 */
export type MypageCommonSetConstruction = {
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

/**
 * デフォルト
 */
export const DEFAULT_MYPAGE_DATA: MypageCommonContext = {
  isSidebarOpen: false,
};
const DEFAULT_MYPAGE_SET_FUNC: MypageCommonSetConstruction = {
  setIsSidebarOpen: () => undefined,
};

/**
 * create
 */
export const MypageCommonContext = createContext<MypageCommonContext>(DEFAULT_MYPAGE_DATA);
export const MypageCommonSetContext =
  createContext<MypageCommonSetConstruction>(DEFAULT_MYPAGE_SET_FUNC);

/**
 * use
 */
export const useMypageCommonContext = () => useContext(MypageCommonContext);
export const useMypageCommonSetContext = () => useContext(MypageCommonSetContext);
